import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAMap from 'vue-amap'
import store from './store'
import { get, post } from './utils/ajax'
import { commonShare , isWeiXin , getUrlParams } from './utils/common'
import './utils/directives.js'
//import Vconsole from 'vconsole'
//let vConsole = new Vconsole()
//export default vConsole
//去除css默认样式
import "@/assets/css/resetCss.css"
//iconfont
import "@/assets/iconfont/iconfont.css"

//导入全局公共组件
import  '@/components'

import './plugins'




//Vue.use(VueAMap)
//VueAMap.initAMapApiLoader({
//	key:'35a38a410033850bb28f1e4c9d63fa9c',
//	plugin:['AMap.CitySearch'],
//	v:'1.4.4'
//})
Vue.config.productionTip = false
Vue.$get = Vue.prototype.$get = get
Vue.$post = Vue.prototype.$post = post
Vue.getUrlParams = Vue.prototype.getUrlParams = getUrlParams
Vue.isWeiXin = Vue.prototype.isWeiXin = isWeiXin
Vue.commonShare = Vue.prototype.commonShare = commonShare

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
